import { DateTime } from 'luxon';

export const revealDate = (
  dateArr: {
    interval: string;
    time: string[];
  }[]
): DateTime<boolean>[] => {
  if (!dateArr) return [];
  return dateArr
    .flatMap((date) => {
      if (date.interval.indexOf('-') > -1) {
        const [start, finish] = date.interval.split(' - ');
        const daysDiff =
          (new Date(finish).getTime() - new Date(start).getTime()) /
          (24 * 60 * 60 * 1000);
        return new Array(daysDiff + 1).fill(0).flatMap(() =>
          Array((date.time && date.time.length) || 1)
            .fill(0)
            .map((_item, subIndex) => {
              const time = date.time[subIndex];
              const isInterval = !!time && !!time.length;

              return isInterval
                ? DateTime.fromFormat(
                    `${start} ${date.time[subIndex]}`,
                    'yyyy-MM-dd HH:mm:ss'
                  )
                : DateTime.fromFormat(`${start}`, 'yyyy-MM-dd');
            })
        );
      }
      return [];
    })
    .filter(
      (i: DateTime) =>
        Math.round(i.valueOf() / 1000 - Date.now() / 1000) >
        (i.toFormat('HH:mm') === '00:00' ? -24 * 60 * 60 : -0)
    )
    .sort((a: DateTime, b: DateTime) => a.valueOf() - b.valueOf());
};
